
export default {
    upload: null,
    uploading: false,
    brk: null,
    resourcePath: null,
    fieldPath: null
}


// WEBPACK FOOTER //
// ./public/pages/StoreFinderImport/initialState.js